// src/pages/Favorites.tsx
import React from 'react';
import { useFavorites } from '../context/FavoritesContext';
import FavoriteListItem from '../components/FavoriteListItem';
import { Recipe } from '../api/Types';
import { EmptyState, Heading, ListGroup, Page, Spinner } from '../components/ui';
// Removed unused import: import { getAuthorColor } from '../utils/colorUtils';

const Favorites: React.FC = () => {
  const { favorites, removeFavorite, favoritePendingIds, favoritesLoading } = useFavorites();

  return (
    <Page fluid marginTop={0}> {/* Use container-fluid and remove top margin */}
      <Heading as="h1" textAlign="center" marginY={4}>Mes coups de coeur</Heading>
      {favoritesLoading ? (
        <Spinner label="Chargement des favoris..." />
      ) : favorites.length === 0 ? (
        <EmptyState variant="light">Vous n'avez aucune recette en favori.</EmptyState>
      ) : (
        <ListGroup>
          {favorites.map((recipe: Recipe) => (
            <FavoriteListItem
              key={recipe.id}
              recipe={recipe}
              onRemoveFavorite={removeFavorite}
              disabled={favoritePendingIds.includes(recipe.id)}
            />
          ))}
        </ListGroup>
      )}
    </Page>
  );
};

export default Favorites;
